export const SET_CONTACT_DETAILS = "setContactDetails";
